import { Route } from '@angular/router';
import { getActiveTopicsResolver } from '@examdojo/category/v2';
import { TopicsTreeUrlParts } from '@examdojo/topics-tree';
import { RootUrlParts } from '../../app.model';
import { RouteTransition, TransitionResolveFn } from '../../route-transition';
import { TopicLevel2DetailViewComponent } from './topic-level-2-detail-view/topic-level-2-detail-view.component';
import { topicLevel2PageRedirectGuard } from './topic-level-2-page-redirect.guard';

/**
 * On mobile, skip view transitions for detail routes to avoid layout issues
 * with components that need their container's final dimensions (e.g. ECharts charts).
 */
const learnHubDetailTransition: TransitionResolveFn = ({ isMobile }) =>
  isMobile ? RouteTransition.None : undefined;

export enum LearnHubUrlParts {
  Overview = TopicsTreeUrlParts.Overview,
}

export const TOPIC_LEVEL_1_SLUG_PARAM = 'topicLevel1Slug';
export const TOPIC_LEVEL_2_SLUG_PARAM = 'topicLevel2Slug';
export const PAGE_SLUG_PARAM = 'pageSlug';

export const LEARN_HUB_ROUTES: Route[] = [
  {
    path: RootUrlParts.LearnHub,
    loadComponent: () => import('./learn-hub.component').then((m) => m.LearnHubComponent),
    data: { compactView: true },
    children: [
      { path: '', redirectTo: LearnHubUrlParts.Overview, pathMatch: 'full' },
      {
        path: LearnHubUrlParts.Overview,
        loadComponent: () =>
          import('./topic-overview-list/topic-overview-list.component').then((m) => m.TopicOverviewListComponent),
        data: {
          transition: RouteTransition.SlideRelatives,
        },
      },
      {
        path: `:${TOPIC_LEVEL_1_SLUG_PARAM}/:${TOPIC_LEVEL_2_SLUG_PARAM}`,
        component: TopicLevel2DetailViewComponent,
        canActivate: [topicLevel2PageRedirectGuard],
        data: { transition: learnHubDetailTransition },
        resolve: {
          activeTopics: getActiveTopicsResolver({
            topicLevel1SlugParam: TOPIC_LEVEL_1_SLUG_PARAM,
            topicLevel2SlugParam: TOPIC_LEVEL_2_SLUG_PARAM,
          }),
        },
      },
      {
        path: `:${TOPIC_LEVEL_1_SLUG_PARAM}/:${TOPIC_LEVEL_2_SLUG_PARAM}/:${PAGE_SLUG_PARAM}`,
        component: TopicLevel2DetailViewComponent,
        data: { transition: learnHubDetailTransition },
        resolve: {
          activeTopics: getActiveTopicsResolver({
            topicLevel1SlugParam: TOPIC_LEVEL_1_SLUG_PARAM,
            topicLevel2SlugParam: TOPIC_LEVEL_2_SLUG_PARAM,
          }),
        },
      },
    ],
  },
];
